import React, { useState, useEffect } from 'react'
import { Routes, Route, Navigate , useLocation } from "react-router-dom"

import Home from "./pages/Home"
import OldHome from "./pages/Home_old"
import Get from "./pages/get"
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Jobs from './pages/Jobs'
import Faq from './pages/Faq';
import Ovg from './pages/Ovg';
import * as global from './global';

import "./styles/global.css";

function App() {

  const [dummyWidth, setDummyWidth] = useState(window.innerWidth);
  const [dummyIsArabic, setDummyLang] = useState(true);

  function handleViewer() {
    global.setViewerWidth();
    global.setContentWidth();
    global.setViewerMode();
    global.setMobileView();
    setDummyWidth(global.viewerWidth);
  }

  const { pathname, hash, key } = useLocation();

  useEffect(() => {
    console.log('INIT APP');

    const lang = pathname.split('/')[1];
    const isAr = lang != 'en';
    if (isAr != global.isArabic) {
      global.setIsArabic(isAr);
      setDummyLang(global.isArabic);
    }

    if (hash === '') window.scrollTo(0, 0);
    else
      setTimeout(() => {
        const id = hash.replace('#', '');
        const element = document.getElementById(id);
        if (element) element.scrollIntoView();
      }, 0);

    const handleKeydown = (e) => {
      if (e.ctrlKey && (e.keyCode == "61" || e.keyCode == "107" || e.keyCode == "173" || e.keyCode == "109" || e.keyCode == "187" || e.keyCode == "189")) {
        e.preventDefault();
      }
    };
  
    const handleWheel = (e) => {
      if (e.ctrlKey) {
        e.preventDefault();
      }
    };

    document.addEventListener("keydown", handleKeydown);
    document.addEventListener("wheel", handleWheel, { passive: false });
    window.addEventListener('resize', handleViewer);

    return () => {
      document.removeEventListener("keydown", handleKeydown);
      document.removeEventListener("wheel", handleWheel);
      window.removeEventListener('resize', handleViewer);
    }

  }, [pathname, hash, key]);
  

  return (
    <div className="App">
      <Routes>
        {/* Home Routes */}
        <Route path="/" element={<Navigate to="/ar" />} />
        <Route path="/ar"  element={<Home />} />
        <Route path="/en" element={<Home />} />
        <Route path="/old" element={<OldHome />} />
        
        {/* Privacy Routes */}
        <Route path="/privacy" element={<Navigate to="/ar/privacy" />} />
        <Route path="/ar/privacy" element={<Privacy />} />
        <Route path="/en/privacy" element={<Privacy />} />

        {/* Terms Routes */}
        <Route path="/terms" element={<Navigate to="/ar/terms" />} />
        <Route path="/ar/terms" element={<Terms />} />
        <Route path="/en/terms" element={<Terms />} />

        {/* Jobs Routes */}
        <Route path="/jobs" element={<Navigate to="/ar/jobs" />} />
        <Route path="/ar/jobs" element={<Jobs />} />
        <Route path="/en/jobs" element={<Jobs />} />

        {/* FAQ Routes */}
        <Route path="/faq" element={<Navigate to="/ar/faq" />} />
        <Route path="/ar/faq" element={<Faq />} />
        <Route path="/en/faq" element={<Faq />} />

        {/* Get Routes */}
        <Route path="/getapp" element={<Get />} />

        {/* OVG Routes */}
        <Route path="/ovg" element={<Navigate to="/ar/ovg" />} />
        <Route path="/ar/ovg" element={<Ovg />} />
        <Route path="/en/ovg" element={<Ovg />} />


      </Routes>
    </div>
  );
}

export default App;
